import Aos from 'aos';
import React, { Suspense } from 'react';
import btacademy from '../../asset/btacademy.jpg'
import img2 from '../../asset/dailyactivity.jpg'
import img3 from '../../asset/flowbyte.jpg'
// import Project from './Project';
const Project = React.lazy(() => import('./Project')); 

const Projects = () => {
    Aos.init()
    const projects = [
        {
            id:1,
            img:btacademy,
            des:'',
            name:'Bt Academy'
        },
        {
            id:2,
            img:img2,
            des:'',
            name:'Daily Activity'
        },
        {
            id:3,
            img:img3,
            des:'',
            stye:"fade-up",
            name:'Flow Byte'
        }
    ]
    return (
        
        <div className='bg-slate-800'>
            
            <h2 className='text-white text-4xl' >Projects</h2>
            <div className='my-4 grid gap-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1'>
            <Suspense fallback={<h1>Loading profile...</h1>}>
            {
                projects.map(project=><Project project={project}></Project>)
            }
            </Suspense>
           
            </div>
            
        </div>
    );
};

export default Projects; 